import React from "react"
import StockFeaturesUpdate from "./StockFeaturesUpdate"
import DataBadgeCard from "components/Common/DataBadgeCard"
import ThemePlaceholder from "components/Common/ThemePlaceholder"

export default function Features({ stock, loading = false }) {
  const getData = () => {
    if (loading) {
      // Return 3 placeholder items while loading
      return Array.from({ length: 3 }).map((_, idx) => ({
        id: idx,
        name: <ThemePlaceholder style={{ width: 80, height: 0, borderRadius: 6 }} />,
      }))
    }
    return stock?.features || []
  }

  return (
    <DataBadgeCard
      data={getData()}
      icon="bx bx-star"
      title="Features"
      name="features"
      action={loading ? null : <StockFeaturesUpdate stock={stock} />}
    />
  )
}
